import { render, staticRenderFns } from "./WsPagenateTypeB.vue?vue&type=template&id=32ccd056&"
import script from "./WsPagenateTypeB.vue?vue&type=script&lang=js&"
export * from "./WsPagenateTypeB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports